<template>
  <div class="form-group with-icon-right dropdown select-form-group"
       v-dropdown.closeOnMenuClick
       :class="{'has-error': hasErrors()}">
    <div v-if="color === 'default'" class="input-group dropdown-toggle"> <!-- @click="$refs.scrollbar.onContainerResize()"> -->
      <input
        readonly 
        :class="{'has-value': !!displayValue}"
        v-model="displayValue"
        v-validate="'required'"
        :name="name"
        required/>
      <i class="ion ion-chevron-down icon-right input-icon"></i>
      <label class="control-label">{{label}}</label><i class="bar"></i>
      <small v-show="hasErrors()" class="help text-danger">{{ showRequiredError() }}</small>
    </div>

    <div v-if="color != 'default'" class="input-group dropdown-toggle"> <!-- @click="$refs.scrollbar.onContainerResize()"> -->
      <input
        readonly style="color: #e34a4a"
        :class="{'has-value': !!displayValue}"
        v-model="displayValue"
        v-validate="'required'"
        :name="name"
        required/>
      <i class="ion ion-chevron-down icon-right input-icon"></i>
      <label style="color: #e34a4a" class="control-label">{{label}}</label><i class="bar"></i>
      <small v-show="hasErrors()" class="help text-danger">{{ showRequiredError() }}</small>
    </div>

    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <div v-if="searchable" class="select-search-wrapper" @click.stop>
        <input
          class="select-search-input"
          v-model="searchQuery"
          placeholder="Pretraži..."
          ref="searchInput"
        />
      </div>
      <scrollbar ref="scrollbar">
        <div class="dropdown-menu-content">
          <div class="dropdown-item"
               :class="{'selected': isOptionSelected(option)}" v-for="option in filteredOptions"
               @click="selectOption(option)">
            <span class="ellipsis">{{optionKey ? option[optionKey] : option}}</span>
          </div>
        </div>
      </scrollbar>
    </div>
  </div>
</template>

<script>
  import Dropdown from 'directives/Dropdown'
  import Scrollbar from '../vuestic-scrollbar/VuesticScrollbar.vue'

  export default {
    name: 'vuestic-simple-select',
    components: {
      Scrollbar
    },
    directives: {
      dropdown: Dropdown
    },
    data () {
      return {
        displayValue: '',
        validated: false,
        searchQuery: ''
      }
    },
    props: {
      label: String,
      options: Array,
      value: {},
      optionKey: String,
      required: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: 'simple-select'
      },
      color: {
        type: String,
        default: "default"
      },
      searchable: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      filteredOptions () {
        if (!this.searchable || !this.searchQuery.trim()) return this.options
        const q = this.searchQuery.trim().toLowerCase()
        return this.options.filter(option => {
          const val = this.optionKey ? option[this.optionKey] : option
          return String(val).toLowerCase().includes(q)
        })
      }
    },
    mounted () {
      this.updateDisplayValue(this.value)
      this.$emit('input', this.value)
    },

    updated: function () {
      this.updateDisplayValue(this.value)
    },

    methods: {
      isOptionSelected (option) {
        return this.value === option
      },
      selectOption (option) {
        this.updateDisplayValue(option)
        this.$emit('input', option)
        this.searchQuery = ''
      },
      updateDisplayValue (val) {
        this.displayValue = this.optionKey ? val[this.optionKey] : val
      },
      validate () {
        this.validated = true
      },
      isValid () {
        let isValid = true
        if (this.required) {
          isValid = !!this.displayValue
        }
        return isValid
      },
      hasErrors () {
        let hasErrors = false
        if (this.required) {
          hasErrors = this.validated && !this.displayValue
        }
        return hasErrors
      },
      showRequiredError () {
        return `The ${this.name} field is required`
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";

  .select-form-group {
    .dropdown-menu {
      padding: 0;
      .vuestic-scrollbar {
        height: $dropdown-item-height * 10;
      }
    }
    .select-search-wrapper {
      padding: 6px 8px;
      border-bottom: 1px solid #e0e0e0;
      .select-search-input {
        width: 100%;
        border: 1px solid #ccc;
        border-radius: 3px;
        padding: 4px 8px;
        font-size: 13px;
        outline: none;
        &:focus {
          border-color: #4ae;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vuestic-components/vuestic-simple-select/VuesticSimpleSelect.vue